export enum Page {
	TTSMM = '/ttsmm',
	STEAM = '/steam',
	MAIN = '/',
	FAQ = '/faq',
	SETTINGS = '/settings'
}
